import {
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'graphql-hooks';
import { useParams } from 'react-router-dom';
//import CookieConsent from "react-cookie-consent";
import React, { useCallback, useMemo } from 'react';
import {
  Avatar,
  AppBar,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@mui/material';

import {
  USER_REDIRECT_TO_STORE,
} from '../../graphql/user/mutation';
import { StateAuth } from '../../context/auth';
import { User } from '../../types';
import styles from './style';

interface NavProps {
  isConnected: StateAuth;
  user: User;
  logout: () => Promise<void>;
  os: string;
  innerHeight: number;
  redirectToApp: () => void;
}

const Nav: React.FC<NavProps> = React.memo((props) => {
  const {
    isConnected,
    logout,
    redirectToApp,
    os,
    user
  } = props;
  const { codeshare } = useParams();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [userRedirectToStore] = useMutation(USER_REDIRECT_TO_STORE);
  const location = useLocation();
  const navigate = useNavigate();

  const openAppTrad = t('mobileFeed.openApp');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onUserRedirectToStore = useCallback((input: {
    os: string;
    option: string;
  }) => userRedirectToStore({
    variables: {
      input,
    },
  }), [userRedirectToStore]);

  const goToProfile = useCallback(() => {
    navigate('/profile', { replace: true });
  }, [navigate]);

  const goLogout = useCallback(async () => {
    await logout();
    setAnchorEl(null);
  }, [logout]);

  const redirectToAppFromCodeshare = useCallback((codeshare: string) => {
    const nativeSchemaUrl = `https://store.soskills.io/short/${codeshare}?redirect=42`;
    window.open(nativeSchemaUrl, '_self');
  }, []);

  const getTheApp = useCallback(() => {
    if (location.pathname.includes('/short/')) {
      redirectToAppFromCodeshare(codeshare!)
    } else {
      redirectToApp();
    }
    onUserRedirectToStore({
      os,
      option: 'download',
    });
  }, [
    codeshare,
    redirectToApp,
    redirectToAppFromCodeshare,
    location.pathname,
    onUserRedirectToStore,
    os,
  ]);


  // Phone only (on a computer every page is in the connected space): transparent over a video.
  const appBarSx = useMemo(() => {
    const isFeed = location.pathname.includes('/short/') || location.pathname === '/';
    return isFeed ? styles.mobileFeedBar : styles.mobileBar;
  }, [location.pathname]);

  const goBackToHome = useCallback(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <React.Fragment>
      <AppBar
        color="transparent"
        position="fixed"
        variant="outlined"
        sx={appBarSx}
        elevation={0}
      >
        {/*{isConnected === 'CONNECTED' && (
          <CookieConsent
            location="bottom"
            //flipButtons
            buttonText={t('acceptCookies')}
            cookieName="cookieSoSkills"
            style={{
              background: "#1a73e8",
            }}
            buttonStyle={{
              backgroundColor: 'white',
              color: "black",
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '11px',
            }}
            expires={150}
          >
            {t('cookieConsentTxt')}{" "}
          </CookieConsent>
        )}*/}
        <Toolbar variant="dense" sx={styles.mobileToolbar}>
          <IconButton
            //edge="start"
            sx={styles.mobileIconButton}
            aria-label="menu"
            onClick={goBackToHome}
          >
            {
              // eslint-disable-next-line jsx-a11y/alt-text
              <img
                src={`/logo-black.png`}
                style={styles.mobileLogo}
              />
            }
          </IconButton>
          <Typography
            color="white"
            sx={styles.mobileTitle}
            onClick={goBackToHome}
          >
            SOSKILLS
          </Typography>
          {location.pathname !== '/login' && isConnected === StateAuth.NOT_CONNECTED && (
            <Button
              variant="contained"
              disableElevation
              onClick={getTheApp}
              sx={styles.mobileOpenApp}
            >
              {openAppTrad}
            </Button>
          )}
          {isConnected === StateAuth.CONNECTED && (
            <>
              <Button onClick={handleClick}>
                <Avatar
                  alt="profile"
                  src={`${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${user.avatar}`}
                />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                {user.role === 'Admin' && (
                  <MenuItem onClick={goToProfile}>My profile</MenuItem>
                )}
                <MenuItem onClick={goLogout}><Typography color="black">Logout</Typography></MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
});

export { Nav };
